import {DeviceType} from "@app/ir-q-app-common/types/units";
import {validatorOfSOSerial} from "@app/ir-q-app-common/shared/validations";

export type DeviceVersion = "1.0" | "1.2" | "3.0_SKWTH" | "3.0_PRTCH" | "SO" | undefined;

export const getDeviceModel = (unitId: string, device: {
    version?: string,
    type: DeviceType,
    serial: string
}): DeviceVersion => {
    const version = device.version as DeviceVersion;
    if (version && version !== '1.0')
        return version;

    if (device.serial.startsWith("ELQ30S"))
        return '3.0_SKWTH';

    if (device.serial.startsWith("ELQ30P"))
        return '3.0_PRTCH';

    if (validatorOfSOSerial.test(device.serial))
        return 'SO';

    if (device.type === 'som') {
        if (device.serial.startsWith("277010"))
            return "1.0";

        return '1.2';
    } else if (device.type === 'tablet') {
        if (device.serial.startsWith("19"))
            return "1.0";

        return '1.2';
    }

    return version
};